// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-users.modal-verificate{
    width: 100% !important;
    height: 99% !important;
}
.content-card-users{
  height: 94%;
}
.txt-title-user-box-cis.modal-verificate{
    text-align: center;
    word-wrap: break-word;
    width: 80%;
}
.user-box-cis{
    height: 10% !important;
}
.user-box-cis {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 20%;
}
.form-cis-box {
    position: relative;
    display: block;
    width: 80%;
    height: 90%;
  }
.form-cis-box .user-box-cis .label-cis {
    position: absolute;
    top: 0px !important;
    left: 0;
    padding: 10px 0;
    font-size: 10px !important;
    font-weight: bolder;
    color: #003757;
    pointer-events: none;
    transition: .5s;
  }
  .form-cis-box .user-box-cis input:focus ~ .label-cis, .form-cis-box .user-box-cis input:valid ~ .label-cis {
    top: -25px !important;
    left: 0px;
    color: #003757;
    font-size: 12px;
  }



  
  .form-cis-box .user-box-cis input:focus ~ .label-cis,
.form-cis-box .user-box-cis input:valid ~ .label-cis,
.form-cis-box .user-box-cis .active {
    top: -25px !important;
    left: 0px;
    font-size: 12px;
}


.form-cis-box .user-box-cis input {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: #505050;
  margin-bottom: 30px;
  border: none;
  border-bottom: 2px solid #003757;
  border-right: 2px solid #003757;
  outline: none;
  background: transparent;
}

.form-cis-box .user-box-cis input:focus ~ .label-cis,
.form-cis-box .user-box-cis input:valid ~ .label-cis {
  top: -10px;
  left: 0;
  color: #003757;
  font-size: 12px;
}
.form-msg-error{
  color: #ff4646;
  position: absolute;
  left:0;
  /* top:10% */
  bottom: 5%;
  background-color: rgba(255, 211, 211, 0.64);
  width: 99%;
  text-align: center;
  border: 2px solid #ff4646;
  border-radius: 0px 0px 5px 5px;
  
  border-top: none;

}
.head-card-cis {
  position: relative;
  height: 5%;
  width: 100%;
  background: rgba(195,195,195);
  background: #003757;
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkbox-cis{
  height: 25px !important;
  
}
.checkbox-cis:hover{
  cursor: pointer;
}
.label-checkbox-cis{
  left: 55%;
  position: absolute;
  top: 10%;
  color:#003757
}





.container-searchHostCis-list{
  /* background-color: #2c305cbd; */
  width: 100%;
  height: auto;
  box-sizing: border-box;
  position: absolute;
  display: flex;
  justify-content: center;
  max-height: 150px;
  font-size: x-small;
  top: 60%;
  z-index: 3;
  border: 1px solid white;
}
.compact-searchHostCis-list{
    
  width: 100%;
  height: auto;
  box-sizing: border-box;
  position: relative;
  display: block;
  overflow: scroll;
  border: 1px solid rgba(240, 248, 255, 0.575) !important;
  border-radius: 5px;
}
.row-searchHostCis-list{
  background-color: #203969;

position: relative;
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 30px;
/* border-bottom: 1px solid rgba(128, 128, 128, 0.452) ; */
color: #72c1fa;
}
.row-searchHostCis-list:hover{
  background-color: aliceblue;
  cursor: pointer;
}
.cont-row-searchHostCis-txt{
  display: flex;
  justify-content: center;
}
.ip-row-searchHostCis{
  color: aliceblue;
}
.row-searchHostCis-list:hover .ip-row-searchHostCis {
  color: #34373c;
}
.closeListSearch{
  position: absolute;
  top: -20%;
  left: 100%;
  width: 10%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  font-weight: bolder;
  font-size: medium;
}
.closeListSearch:hover{
  font-size: larger;
  cursor: pointer;
}

.read{
  background: #dbdbdb;
}`, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/styles/ModalCreateCis.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;EACE,WAAW;AACb;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,sBAAsB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;EACb;AACF;IACI,kBAAkB;IAClB,mBAAmB;IACnB,OAAO;IACP,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,SAAS;IACT,cAAc;IACd,eAAe;EACjB;;;;;EAKA;;;IAGE,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,UAAU;EACV,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;;EAE9B,gBAAgB;;AAElB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,uBAAuB;;AAEzB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR;AACF;;;;;;AAMA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;AACzB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uDAAuD;EACvD,kBAAkB;AACpB;AACA;EACE,yBAAyB;;AAE3B,kBAAkB;AAClB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,WAAW;AACX,YAAY;AACZ,0DAA0D;AAC1D,cAAc;AACd;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".card-users.modal-verificate{\n    width: 100% !important;\n    height: 99% !important;\n}\n.content-card-users{\n  height: 94%;\n}\n.txt-title-user-box-cis.modal-verificate{\n    text-align: center;\n    word-wrap: break-word;\n    width: 80%;\n}\n.user-box-cis{\n    height: 10% !important;\n}\n.user-box-cis {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 20%;\n}\n.form-cis-box {\n    position: relative;\n    display: block;\n    width: 80%;\n    height: 90%;\n  }\n.form-cis-box .user-box-cis .label-cis {\n    position: absolute;\n    top: 0px !important;\n    left: 0;\n    padding: 10px 0;\n    font-size: 10px !important;\n    font-weight: bolder;\n    color: #003757;\n    pointer-events: none;\n    transition: .5s;\n  }\n  .form-cis-box .user-box-cis input:focus ~ .label-cis, .form-cis-box .user-box-cis input:valid ~ .label-cis {\n    top: -25px !important;\n    left: 0px;\n    color: #003757;\n    font-size: 12px;\n  }\n\n\n\n  \n  .form-cis-box .user-box-cis input:focus ~ .label-cis,\n.form-cis-box .user-box-cis input:valid ~ .label-cis,\n.form-cis-box .user-box-cis .active {\n    top: -25px !important;\n    left: 0px;\n    font-size: 12px;\n}\n\n\n.form-cis-box .user-box-cis input {\n  width: 100%;\n  padding: 10px 0;\n  font-size: 16px;\n  color: #505050;\n  margin-bottom: 30px;\n  border: none;\n  border-bottom: 2px solid #003757;\n  border-right: 2px solid #003757;\n  outline: none;\n  background: transparent;\n}\n\n.form-cis-box .user-box-cis input:focus ~ .label-cis,\n.form-cis-box .user-box-cis input:valid ~ .label-cis {\n  top: -10px;\n  left: 0;\n  color: #003757;\n  font-size: 12px;\n}\n.form-msg-error{\n  color: #ff4646;\n  position: absolute;\n  left:0;\n  /* top:10% */\n  bottom: 5%;\n  background-color: rgba(255, 211, 211, 0.64);\n  width: 99%;\n  text-align: center;\n  border: 2px solid #ff4646;\n  border-radius: 0px 0px 5px 5px;\n  \n  border-top: none;\n\n}\n.head-card-cis {\n  position: relative;\n  height: 5%;\n  width: 100%;\n  background: rgba(195,195,195);\n  background: #003757;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.checkbox-cis{\n  height: 25px !important;\n  \n}\n.checkbox-cis:hover{\n  cursor: pointer;\n}\n.label-checkbox-cis{\n  left: 55%;\n  position: absolute;\n  top: 10%;\n  color:#003757\n}\n\n\n\n\n\n.container-searchHostCis-list{\n  /* background-color: #2c305cbd; */\n  width: 100%;\n  height: auto;\n  box-sizing: border-box;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  max-height: 150px;\n  font-size: x-small;\n  top: 60%;\n  z-index: 3;\n  border: 1px solid white;\n}\n.compact-searchHostCis-list{\n    \n  width: 100%;\n  height: auto;\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  overflow: scroll;\n  border: 1px solid rgba(240, 248, 255, 0.575) !important;\n  border-radius: 5px;\n}\n.row-searchHostCis-list{\n  background-color: #203969;\n\nposition: relative;\ndisplay: flex;\njustify-content: center;\nalign-items: center;\nwidth: 100%;\nheight: 30px;\n/* border-bottom: 1px solid rgba(128, 128, 128, 0.452) ; */\ncolor: #72c1fa;\n}\n.row-searchHostCis-list:hover{\n  background-color: aliceblue;\n  cursor: pointer;\n}\n.cont-row-searchHostCis-txt{\n  display: flex;\n  justify-content: center;\n}\n.ip-row-searchHostCis{\n  color: aliceblue;\n}\n.row-searchHostCis-list:hover .ip-row-searchHostCis {\n  color: #34373c;\n}\n.closeListSearch{\n  position: absolute;\n  top: -20%;\n  left: 100%;\n  width: 10%;\n  height: 70%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: red;\n  font-weight: bolder;\n  font-size: medium;\n}\n.closeListSearch:hover{\n  font-size: larger;\n  cursor: pointer;\n}\n\n.read{\n  background: #dbdbdb;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
